import type { City, GroupedStations } from "@repo/ui/types/stations";

export function transformStationsWithMacCodes(stations: GroupedStations | null): GroupedStations {
  if (!stations) return {};
  const transformedStations: GroupedStations = {};
  const processedMacCodes = new Set<string>();

  Object.entries(stations).forEach(([country, cities]) => {
    const newCities: City[] = [];

    cities.forEach((city) => {
      if (city.macCode && city.macCodeName) {
        const macKey = `${country}-${city.macCode}`;

        if (!processedMacCodes.has(macKey)) {
          newCities.push({
            ...city,
            city: city.macCodeName,
            code: city.macCode,
            cityCode: city.macCode,
            stationCode: city.macCode,
            fullName: city.macCodeName,
          });
          processedMacCodes.add(macKey);
        }

        newCities.push({
          ...city,
          hidden: true,
        });
      } else {
        newCities.push(city);
      }
    });

    if (newCities.length > 0) {
      transformedStations[country] = newCities;
    }
  });

  return transformedStations;
}
